module.exports = __webpack_public_path__ + "img/FR16773.d7deb089.png";